import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfigService } from '../../../../core/app-config';
import { OAuthTokenService } from '../../../../core/oauth-shared/oauth-token.service';
import { setupSubmission } from '../../../../store/shared/dcr-form-submission/api/form-submission-twostep.api';
import { ContactUsPayload } from '../types/contact-us.state.type';

@Injectable({ providedIn: 'root' })
export class ContactUsApi {
  contactUsUrl: string;
  contactUsFormSubmission: (requestBody: ContactUsPayload) => Observable<any>;

  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigService,
    private oAuthTokenService: OAuthTokenService,
  ) {
    this.contactUsUrl = this.appConfig.contactUsUrl;
    this.contactUsFormSubmission = setupSubmission(
      {
        httpClient: this.httpClient,
        appConfig: this.appConfig,
        oAuthTokenService: this.oAuthTokenService,
      },
      this.contactUsUrl,
    );
  }
}
